export enum ResponseStatus {
  Success = 1,
  Error = 2,
  ServerError = 3,
  OperationFailed = 4
}

export enum LoggingLevel {
  Audit = 1,
  Error = 2,
  Info = 3,
  Warn = 4,
  Verbose = 5
}

export enum LogCategoryEnum {
  Unknown = 0,
  Error,
  StatusChange,
  FARSChange,
  InvestigatorReportChange,
  CodeListChange,
  CodeListValueChange,
  RoleChange,
  UserRoleAdd,
  UserRoleRemove,
  UserChange,
  VendorEdit,
  BackgroundTask,
  SendTo,
  ThirdPartySubmission,
  CrashKeyGeneration,
  LocationUpdated,

}

export enum ElasticIndices {
  Error = "Error",
  System = "System",
  Reports = "Reports",
  Administration = "Administration",
  Audit = "Audit"
}

export enum ExternalInputSource {
  None = "None",
  Scanner = "Scanner",
  RMS = "RMS"
}


export enum FormioEditNavigationItem {
  Back,
  EnterData,
  EditForm,
  Validation,
  Delete
}

export enum WorkFlowStepEnum {
  KEYWORDS = -1,
  LOCATION = -2,
  DATAENTRY = -3,
  REVIEW = -4,
  QA = -5
}

export enum eFormElementType {
  Textbox,
  Dropdown,
  Empty,
  TextArea
}

export enum FormSaveStatus {
	Unset,
	Success,
	Failure
}
